import { Node } from 'tiptap'

class Div extends Node {
  get name() {
    return 'div'
  }

  get schema() {
    return {
      content: 'block*',
      draggable: false,
      selectable: false,
      group: 'block',
      parseDOM: [
        {
          tag: 'div',
        },
      ],
      toDOM() {
        return ['div', 0]
      },
    }
  }
}

export default Div
